import type { PriceSnapshot, Product } from "../mocks/products";

export const formatPrice = (value: number | null | undefined): string => {
  if (value === null || value === undefined) {
    return "Pending";
  }
  return new Intl.NumberFormat("vi-VN", {
    style: "currency",
    currency: "VND",
    maximumFractionDigits: 0,
  }).format(value);
};

export const formatCompactPrice = (value: number | null | undefined): string => {
  if (value === null || value === undefined) {
    return "Pending";
  }
  return new Intl.NumberFormat("vi-VN", {
    notation: "compact",
    maximumFractionDigits: 1,
  }).format(value);
};

export const formatShortDate = (isoValue: string | undefined): string => {
  if (!isoValue) {
    return "Pending";
  }
  return new Intl.DateTimeFormat("en-GB", {
    day: "2-digit",
    month: "short",
  }).format(new Date(isoValue));
};

export const formatDateTime = (isoValue: string | undefined): string => {
  if (!isoValue) {
    return "Pending";
  }
  return new Intl.DateTimeFormat("vi-VN", {
    day: "2-digit",
    month: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  }).format(new Date(isoValue));
};

export const getLowestSnapshot = (snapshots: PriceSnapshot[]): PriceSnapshot | undefined =>
  snapshots.reduce<PriceSnapshot | undefined>(
    (lowest, snapshot) =>
      !lowest || snapshot.price < lowest.price ? snapshot : lowest,
    undefined,
  );

export const getHighestSnapshot = (snapshots: PriceSnapshot[]): PriceSnapshot | undefined =>
  snapshots.reduce<PriceSnapshot | undefined>(
    (highest, snapshot) =>
      !highest || snapshot.price > highest.price ? snapshot : highest,
    undefined,
  );

export const getPreviousSnapshot = (snapshots: PriceSnapshot[]): PriceSnapshot | undefined =>
  snapshots.length > 1 ? snapshots[snapshots.length - 2] : undefined;

export const getPriceDelta = (product: Product): number | undefined => {
  const previous = getPreviousSnapshot(product.snapshots);
  if (!previous || product.latestPrice === null) {
    return undefined;
  }
  return product.latestPrice - previous.price;
};

export const getCollectedDaysLabel = (snapshots: PriceSnapshot[]): string => {
  if (snapshots.length === 0) {
    return "0 snapshots";
  }
  const first = new Date(snapshots[0].capturedAt);
  const last = new Date(snapshots[snapshots.length - 1].capturedAt);
  const days = Math.max(
    1,
    Math.round((last.getTime() - first.getTime()) / (24 * 60 * 60 * 1000)) + 1,
  );
  return `${snapshots.length} snapshots / ${days} days`;
};
